import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { apiReportDataToReportData, IApiGetReportDataReq, IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

const HTTP_NOT_FOUND = 404;

export const loadReportDataEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetPayload(MarkoutAction.loadReportData.started),
    switchMap((params) => {
      const apiParams: IApiGetReportDataReq = {
        sort: params.sort,
        limit: params.limit,
        skip: params.skip,
        servers: params.servers,
        accountGroups: params.accountGroups,
        symbols: params.symbols,
        accounts: params.accounts,
        riskLevel: params.riskLevel,
        side: params.side,
        minNotional: params.minNotional,
      };
      const isReportData = params.reportId !== undefined && params.jobId !== undefined;
      const request$ = isReportData
        ? moApi.getReportData(params.reportId, params.jobId, apiParams)
        : moApi.getDashboardData(apiParams);

      return request$.pipe(
        mergeMap((response) => [
          MarkoutAction.loadReportData.done({
            params,
            result: apiReportDataToReportData(response.data),
          }),
        ]),
        // Workaround (LB-5232): the backend 404s the Current Day dashboard until the tenant is
        // provisioned and the first hourly job has run. For the user that is an empty day, not a
        // failure: answer with no data so the "There is no data" stub shows instead of the error
        // one. Drop once the backend returns 200 for an empty day.
        catchApiError((error) => [
          !isReportData && error.status === HTTP_NOT_FOUND
            ? MarkoutAction.loadReportData.done({ params, result: apiReportDataToReportData(null) })
            : MarkoutAction.loadReportData.failed({ params, error }),
        ]),
      );
    }),
  );
